var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-profile-collection-answers"},[_c('JoLoadMore',{ref:"loadmore",attrs:{"auto-load":false},on:{"onRefresh":_vm.onRefresh,"onLoadMore":_vm.onLoadMore}},[_c('ul',_vm._l((_vm.answerList),function(answer){return _c('QuestionAnswerCard',{key:answer.id,attrs:{"answer":answer,"allow-adopt":false,"no-user":true}})}),1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }